import React, { Component } from "react";
import {FaUser, FaUniversity, FaUsers, FaBuilding } from "react-icons/fa";
import Title from "./Title";
import { Link } from "react-router-dom";

export default class Pricing extends Component {
 state = {
    services: [
      {
        icon: <FaUser />,
        price : 1300,
        priceYearly : 12480,
        title: "Individuals",
        aboutplna: "economy",
        info:
          ""
      },
      {
        icon: <FaUsers />,
        price : 1500,
         priceYearly : 14400,
        title: "small business",
        info:
          " "
      },
      {
        icon: <FaBuilding/>,
        price : 3000,
        priceYearly : 28800,
        title: "medium business",
        info:
          " "
      },
      {
        icon: <FaUniversity />,
        price : 6000,
        priceYearly : 57600,
        title: "Entreprises",
        info:
          ""
      }
    ]
  };
 render() {
    return (
      <section className="services">
        <Title title="choose a plan that is best for your organization" />
        <div className="services-center">
          {this.state.services.map(item => {
            return (
              <article key={`item-${item.title}`} className="service">
                <span>{item.icon}</span>
                <h6>{item.title}</h6>
                <p>{item.info}</p>
                <br/>
                <h3>Ksh.{item.price}/month</h3>
                <p>or</p>
                <br/>
                <h3>Ksh.{item. priceYearly}/year <br/><small>(20% discount)</small></h3>
              
               <Link to="/register" className="btn-primary">
            select
          </Link>
              </article>
            );
          })}
        </div>
      </section>
    );
  }
}
